const BOXCAST_URL_REGEXP = /boxcast\.com/;
angular.module('app.directives').directive('notBoxcast', ($rootScope) => {
  'ngInject';

  return {
    require: 'ngModel',
    link: (scope, elm, attrs, ctrl) => {
      ctrl.$validators.notBoxcast = (modelValue, viewValue) => {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }

        // If rtmp_chaining feature is enabled, allow BoxCast URLs
        if (
          $rootScope.account &&
          $rootScope.account.extra_features &&
          $rootScope.account.extra_features.rtmp_chaining
        ) {
          return true;
        }

        return !BOXCAST_URL_REGEXP.test(viewValue);
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/not-boxcast.js